import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { fetchBrandOptions, type BrandOptionItem } from "@app/api/product/brand";

export interface BrandSelectOption {
    label: string;
    value: string;
}

/** 客户端品牌下拉（页面打开时拉取，不做会话缓存） */
export const useBrandOptionsStore = defineStore("brandOptions", () => {
    const items = ref<BrandOptionItem[]>([]);
    const loading = ref(false);

    const selectOptions = computed<BrandSelectOption[]>(() =>
        items.value.map(item => ({
            label: item.name,
            value: item.id,
        })),
    );

    async function fetchOptions() {
        if (loading.value) return;

        loading.value = true;
        try {
            const data = await fetchBrandOptions();
            items.value = data.items ?? [];
        } catch (e) {
            console.error("[brandOptions]", e);
            items.value = [];
        } finally {
            loading.value = false;
        }
    }

    function reset() {
        items.value = [];
        loading.value = false;
    }

    return { items, loading, selectOptions, fetchOptions, reset };
});
